<template>
  <v-menu
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="600"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn icon
                 class="mr-2"
                 :color="iconColor"
                 v-on="{ ...onTooltip, ...on }"
                 @click.stop.prevent=""
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
        </template>
        <span>Filtrar por</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense class="mt-1">
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Data Entrada Inicial"
                            v-model="localDataInicial"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-date-picker dense
                            input-class="rounded-tag-small"
                            label="Data Entrada Final"
                            v-model="localDataFinal"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <px-autocomplete-comprador
              required
              dense
              class="rounded-tag-small"
              v-model="localEmpresa"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-user-comprador-multiple
              required
              dense
              :roles="[]"
              class="rounded-tag-small"
              v-model="localResponsavel"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-produto-multiple
              v-model="localProduto"
              class="rounded-tag-small"
              show-details
              dense
              base-path="/produtos/page"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-centro-custo-multiple
              class="rounded-tag-small"
              dense
              v-model="localCentroCusto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-projeto-multiple
              dense
              class="rounded-tag-small"
              v-model="localProjeto"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-fornecedor-multiple
              class="rounded-tag-small"
              dense
              search-in-cotacao
              search-by-codigo-interno
              v-model="localFornecedor"/>
          </v-col>
        </v-row>
        <v-row dense class="mt-1">
          <v-col cols="12">
            <px-autocomplete-grupo-multiple
              dense
              class="rounded-tag-small"
              v-model="localGrupo"/>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-3">
        <v-spacer/>
        <v-btn text class="normal-btn-text" @click="clearFilters">
          Limpar filtros
        </v-btn>
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="emitChange">
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {},
  data: () => ({
    menuOpened: false,
    localEmpresa: null,
    localCentroCusto: [],
    localProduto: [],
    localProjeto: [],
    localResponsavel: [],
    localFornecedor: [],
    localGrupo: [],
    localDataInicial: null,
    localDataFinal: null,
  }),
  computed: {
    ...mapGetters('listagemCotacao', ['hasCustomFilters']),
    iconColor() {
      return this.hasCustomFilters ? 'primary' : '';
    },
    empresa: {
      get() {
        return this.$store.getters['listagemCotacao/empresa'];
      },
      set(empresa) {
        this.$store.dispatch('listagemCotacao/empresa', empresa);
      },
    },
    centroCusto: {
      get() {
        return this.$store.getters['listagemCotacao/centroCusto'];
      },
      set(centroCusto) {
        this.$store.dispatch('listagemCotacao/centroCusto', centroCusto);
      },
    },
    produto: {
      get() {
        return this.$store.getters['listagemCotacao/produto'];
      },
      set(produto) {
        this.$store.dispatch('listagemCotacao/produto', produto);
      },
    },
    projeto: {
      get() {
        return this.$store.getters['listagemCotacao/projeto'];
      },
      set(projeto) {
        this.$store.dispatch('listagemCotacao/projeto', projeto);
      },
    },
    responsavel: {
      get() {
        return this.$store.getters['listagemCotacao/responsavel'];
      },
      set(responsavel) {
        this.$store.dispatch('listagemCotacao/responsavel', responsavel);
      },
    },
    fornecedor: {
      get() {
        return this.$store.getters['listagemCotacao/fornecedor'];
      },
      set(fornecedor) {
        this.$store.dispatch('listagemCotacao/fornecedor', fornecedor);
      },
    },
    dataFinal: {
      get() {
        return this.$store.getters['listagemCotacao/dataFinal'];
      },
      set(dataFinal) {
        this.$store.dispatch('listagemCotacao/dataFinal', dataFinal);
      },
    },
    dataInicial: {
      get() {
        return this.$store.getters['listagemCotacao/dataInicial'];
      },
      set(dataInicial) {
        this.$store.dispatch('listagemCotacao/dataInicial', dataInicial);
      },
    },
    grupo: {
      get() {
        return this.$store.getters['lsitagemCotacao/grupo'];
      },
      set(grupos) {
        this.$store.dispatch('listagemCotacao/grupo', grupos);
      },
    },
  },
  methods: {
    emitChange() {
      this.empresa = this.localEmpresa;
      this.centroCusto = this.localCentroCusto;
      this.produto = this.localProduto;
      this.projeto = this.localProjeto;
      this.responsavel = this.localResponsavel;
      this.fornecedor = this.localFornecedor;
      this.dataInicial = this.localDataInicial;
      this.dataFinal = this.localDataFinal;
      this.grupo = this.localGrupo;
      this.$emit('change');
      this.close();
    },
    clearFilters() {
      this.localEmpresa = null;
      this.localCentroCusto = null;
      this.localProduto = null;
      this.localProjeto = null;
      this.localResponsavel = null;
      this.localFornecedor = null;
      this.localDataInicial = null;
      this.localDataFinal = null;
      this.localGrupo = null;
      this.emitChange();
    },
    close() {
      this.menuOpened = false;
    },
  },
  created() {
    this.localEmpresa = this.empresa || null;
    this.localCentroCusto = this.centroCusto || [];
    this.localProduto = this.produto || [];
    this.localProjeto = this.projeto || [];
    this.localResponsavel = this.responsavel || [];
    this.localFornecedor = this.fornecedor || [];
    this.localDataInicial = this.dataInicial || null;
    this.localDataFinal = this.dataFinal || null;
    this.localGrupo = this.grupo || [];
  },
};
</script>
